module.exports = __webpack_public_path__ + "static/media/docs.44849a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/docs/docs.png
// module id = 174
// module chunks = 0